import React from "react"
import Article from "./Article"
import EmptyBlock from "./EmptyBlock"
import styles from "./BannerHome.module.scss"
import BannerContainer from "@components/BannerContainer"

const BannerApps = props => {
  return (
    <BannerContainer
      renderLeftWrapperChildren={() => {
        return (
          <React.Fragment>
            <Article pathContext={props.pathContext} />
            <EmptyBlock className={styles.emptyBlockLeft} />
          </React.Fragment>
        )
      }}
      renderRightWrapperChildren={() => {
        return (
          <React.Fragment>
            <div className={styles.logoWithEngineID}>
              <img
                src={require("../../../images/apps/" + props.pathContext.icon)}
                alt={props.pathContext.appName}
                className={styles.macbook + " align-items-baseline"}
              />
              <br />
              +
              <br />
              <img
                src={require("../../../images/logo-white.png")}
                alt="EngineID"
                className={styles.macbook + " align-items-baseline"}
              />
            </div>
            <EmptyBlock className={styles.emptyBlockRight} />
          </React.Fragment>
        )
      }}
    />
  )
}

export default BannerApps
